import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'upsc-outage-banner',
  templateUrl: './outage-banner.component.html',
  styleUrls: ['./outage-banner.component.scss']
})
export class OutageBannerComponent {
  @Input() message = '';
  @Input() visible = true;

  @Output() closed = new EventEmitter<void>();

  closeBanner(): void {
    this.visible = false;
    this.closed.emit();
  }
}
